import React, { useState } from 'react';
import Icon from './Icon';

/**
 * Small square icon button. Used for kebab menus and other utility
 * actions that don't deserve a labeled button. Hover state lifts the
 * background to --bg-hover and the icon color from --text-3 → --text-1.
 *
 *   name     icon name (passed to Icon)
 *   label    aria-label and tooltip
 *   onClick  click handler
 *   danger   true → resting + hover color shift to --danger
 *   size     px; default 28
 */
export default function IconBtn({
  name,
  label,
  onClick,
  danger = false,
  size = 28,
  iconSize = 15,
  style,
}) {
  const [hover, setHover] = useState(false);
  const base = danger ? 'var(--danger)' : 'var(--text-3)';
  const lift = danger ? 'var(--danger)' : 'var(--text-1)';
  return (
    <button
      type="button"
      title={label}
      aria-label={label}
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        width: size,
        height: size,
        borderRadius: 6,
        color: hover ? lift : base,
        background: hover ? 'var(--bg-hover)' : 'transparent',
        border: 'none',
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
        transition: 'background .1s, color .1s',
        ...style,
      }}
    >
      <Icon name={name} size={iconSize} />
    </button>
  );
}
